module.exports = __webpack_public_path__ + "img/ko_kaeri1.4041b34c.jpg";